import React, { Component } from 'react'
import styled from 'styled-components'
import gql from 'graphql-tag'
import { Container, Row, Col, media } from 'styled-bootstrap-grid'
import easing from 'ui/styles/easing'

import withQuery from 'containers/withQuery'

import FacebookIcon from './FacebookIcon'
import YouTubeIcon from './YouTubeIcon'
import InstagramIcon from './InstagramIcon'

const Wrapper = styled.div`
  padding-bottom: 40px;
  background-color: ${props => props.theme.colors.oxford.base};
  color: white;

  p a {
    color: inherit;
  }

  ${media.xs`
    padding-bottom: 0;
  `}
`

const Title = styled.h2`
  font-size: 25px;
  font-family: ${props => props.theme.displayFont};
  font-weight: 600;

  ${media.xs`
    display: none;
  `}
`

const Heading = styled.h4`
  margin: 0;
  color: ${props => props.theme.colors.grey.lightest};
  font-family: ${props => props.theme.bodyFont};
  font-weight: 600;
`

const ToTop = styled.div`
  display: inline-block;
  font-weight: 600;
  
  &:hover {
    cursor: n-resize;
  }

  svg {
    margin-right: 1em;
  }

  svg, p {
    display: inline-block;
  }
`

const SoMe = styled(Row)`
  transform: translateY(-50%);
  position: relative;
  z-index: 11;

  ${media.xs`
    padding: 0 10px;
  `}
`

const SoMeLink = styled.a`
  background: ${props => props.theme.colors.oxford.dark};
  flex: 1;
  display: flex;
  align-items: center;
  color: inherit;
  transition: background-color 0.3s ${easing.easeOutCubic};
  
  &:hover {
    background: ${props => props.theme.colors.oxford.base};
  }

  p {
    margin: 0;
    padding: 0 23px;
    font-family: ${props => props.theme.displayFont};
    font-size: 20px;
    line-height: 40px;
    font-weight: 600;

    ${media.xs`
      display: none;
    `}
  }

  ${media.xs`
    justify-content: center;
  `}
`

const Copyright = styled.p`
  font-size: 14px;
  font-weight: 600;
  color: ${props => props.theme.colors.grey.base};
  
  ${media.xs`
    margin-top: 40px;
  `}
`

class Footer extends Component {
  scrollToTop() {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    })
  }
  
  render() {
    const {
      optionsFooterLoading,
    } = this.props

    const {
      address,
      phone,
      email,
      officeHours,
      facebookLink,
      facebookText,
      youtubeLink,
      youtubeText,
      instagramLink,
      instagramText,
      intranetLink,
    } = this.props.optionsFooter

    if (optionsFooterLoading) return null
    
    return (
      <Wrapper>
        <Container fluid>
        
          <SoMe>
            <SoMeLink
              href={facebookLink}
              target="_blank"
            >
              <FacebookIcon />
              <p>{facebookText}</p>
            </SoMeLink>
            <SoMeLink
              href={youtubeLink}
              target="_blank"
            >
              <YouTubeIcon />
              <p>{youtubeText}</p>
            </SoMeLink>
            <SoMeLink
              href={instagramLink}
              target="_blank"
            >
              <InstagramIcon />
              <p>{instagramText}</p>
            </SoMeLink>
          </SoMe>
          
          <Row style={{margin: '0 0 40px'}}>
            <Col sm={6}>
              <Title>Vesterdal Efterskole</Title>
            </Col>
            <Col
              sm={6}
              style={{textAlign: 'right'}}
            >
              <ToTop onClick={() => this.scrollToTop()}>
                <svg
                  width="10"
                  height="16"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill="#FFF"
                    fillRule="evenodd"
                    d="M5.00488281.3359375l4.21875 4.21875H5.72753906V16h-1.4453125V4.5546875H.78613281z"
                  />
                </svg>
                <p>Til toppen</p>
              </ToTop>
            </Col>
          </Row>
          
          <Row>
            <Col
              xsOrder={4}
              sm={6}
              alignSelf="end"
            >
              <Copyright>
                {intranetLink &&
                  <div>
                    <a href={intranetLink.url} target="_blank">{intranetLink.title}</a>
                    <br /><br />
                  </div>
                }
                &copy; {(new Date()).getFullYear()} Vesterdal Efterskole
              </Copyright>
            </Col>
            <Col sm={2}>
              <Heading>Adresse</Heading>
              <p dangerouslySetInnerHTML={{ __html: address }} />
            </Col>
            <Col sm={2}>
              <Heading>Kontakt</Heading>
              <p>
                {phone &&
                  <a href={`tel:${phone}`}>{phone}</a>
                }
                <br />
                {email &&
                  <a href={`mailto:${email}`}>{email}</a>
                }
              </p>
            </Col>
            <Col sm={2}>
              <Heading>Kontortid</Heading>
              <p dangerouslySetInnerHTML={{ __html: officeHours }} />
            </Col>
          </Row>
        
        </Container>
      </Wrapper>
    )
  }
}

export default withQuery(() => gql`
  {
    optionsFooter {
      address
      phone
      email
      officeHours
      facebookLink
      facebookText
      youtubeLink
      youtubeText
      instagramLink
      instagramText
      intranetLink {
        url
        title
      }
    }
  }
`, 'optionsFooter')(Footer)



// WEBPACK FOOTER //
// ./src/ui/components/Footer/index.js